// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sidebar .sidebar-widget .detailed-weather-widget-item{width:100%}.sidebar .sidebar-widget .detailed-weather-widget-item svg.current{height:5rem;width:5rem}.sidebar .sidebar-widget .detailed-weather-widget-item .search-select-input{min-width:8rem}.posts-list .feed-widget .detailed-weather-widget-item{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
